import { RequestStatus } from 'features/request/requestSlice';
import type { ContractNavigationData } from 'gql/graphql';
import { ProjectContractTypeEnum } from 'gql/graphql';
import { useProjectData } from 'hooks/useProjectData';
import type { AnyObject } from 'types/AnyObject';

import * as R from 'ramda';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

interface IUseSetIsWorkOrderChangeRequired {
    useData: AnyObject | undefined | null;
    status: RequestStatus;
}

export const useSetIsWorkOrderChangeRequired = ({ useData, status }: IUseSetIsWorkOrderChangeRequired) => {
    const { id: idProject, orderId: workOrderId } = useParams();

    const { projectData, setProjectData } = useProjectData(idProject);

    useEffect(() => {
        if (status === RequestStatus.SUCCESS && useData) {
            const isWorkOrderChangeRequired = useData?.isWorkOrderChangeRequired;
            const isContractTypeFrame = projectData?.contractType === ProjectContractTypeEnum.Frame;
            const isContractTypeNormal = projectData?.contractType === ProjectContractTypeEnum.Normal;

            if (isContractTypeFrame) {
                const workOrderNavs = projectData?.contractNavigation?.data?.workOrderNavs?.map((item) => {
                    if (item.id === Number(workOrderId)) {
                        return { ...item, metadata: { ...item.metadata, isWorkOrderChangeRequired } };
                    }

                    return item;
                });

                if (R.not(R.equals(workOrderNavs, projectData?.contractNavigation?.data?.workOrderNavs))) {
                    setProjectData({
                        ...projectData,
                        contractNavigation: {
                            ...projectData?.contractNavigation,
                            hasValidation: Boolean(projectData?.contractNavigation?.hasValidation),
                            result: Boolean(projectData?.contractNavigation?.result),
                            data: {
                                ...projectData?.contractNavigation?.data,
                                workOrderNavs,
                            } as ContractNavigationData,
                        },
                    });
                }
            }

            if (isContractTypeNormal) {
                const contractNavItems = projectData?.contractNavigation?.data?.contractNavItems?.map((item) => {
                    if (item.id === Number(workOrderId)) {
                        return { ...item, metadata: { ...item.metadata, isWorkOrderChangeRequired } };
                    }

                    return item;
                });

                if (R.not(R.equals(contractNavItems, projectData?.contractNavigation?.data?.contractNavItems))) {
                    setProjectData({
                        ...projectData,
                        contractNavigation: {
                            ...projectData?.contractNavigation,
                            hasValidation: Boolean(projectData?.contractNavigation?.hasValidation),
                            result: Boolean(projectData?.contractNavigation?.result),
                            data: {
                                ...projectData?.contractNavigation?.data,
                                contractNavItems,
                            } as ContractNavigationData,
                        },
                    });
                }
            }
        }
    }, [projectData, setProjectData, status, useData, workOrderId]);
};
